import { LanguageType } from "@/lib/main";

const languages: LanguageType[] = [
  {
    key: "ar",
    htmlLanguage: "ar-EG",
    name: "العربية",
    textDirection: "rtl",
    ar: "العربية",
    en: "Arabic",
  },
  {
    key: "en",
    htmlLanguage: "en-US",
    name: "English",
    textDirection: "ltr",
    ar: "الإنجليزية",
    en: "English",
  },
];

export default languages;

// * default language is English
export const defaultLanguage = languages[1];
